import * as Action from './actions';
import { lastWeekTime, todayLastTime, now, april14, april20 } from '../../../utils/helpers';

const fromDate = localStorage.getItem('startDate');
const toDate = localStorage.getItem('endDate');
const lastUpdate = localStorage.getItem('lastUpdate');

const initialState = {
  // startDate: fromDate ? new Date(fromDate) : lastWeekTime,
  // endDate: toDate ? new Date(toDate) : todayLastTime,
  // lastUpdate: lastUpdate ? new Date(lastUpdate) : now,
  startDate: fromDate ? new Date(fromDate) : april14,
  endDate: toDate ? new Date(toDate) : april20,
  lastUpdate: lastUpdate ? new Date(lastUpdate) : april20,
  lastStartDate: null,
  lastEndDate: null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case Action.UPDATE_START_DATE: {
      localStorage.setItem('startDate', action.payload);
      return {
        ...state,
        startDate: action.payload,
      };
    }
    case Action.UPDATE_END_DATE: {
      localStorage.setItem('endDate', action.payload);
      return {
        ...state,
        endDate: action.payload,
      };
    }
    case Action.UPDATE_LAST_UPDATE: {
      localStorage.setItem('lastUpdate', action.payload);
      return {
        ...state,
        lastUpdate: action.payload,
      };
    }
    case Action.UPDATE_LAST_START_DATE: {
      localStorage.setItem('lastStartDate', action.payload);
      return {
        ...state,
        lastStartDate: action.payload,
      };
    }
    case Action.UPDATE_LAST_END_DATE: {
      localStorage.setItem('lastEndDate', action.payload);
      return {
        ...state,
        lastEndDate: action.payload,
      };
    }

    default:
      return state;
  }
};
